// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__1jYc3","Label":"BuildControl__Label__33Z-p","Less":"BuildControl__Less__377MJ","More":"BuildControl__More__28-hQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 156
// module chunks = 3